export const encodeMedia = (img) => {
  let reader = new FileReader();

  return new Promise((resolve, reject) => {
    reader.onloadend = () => {
      resolve(reader.result);
    }

    reader.readAsDataURL(img);
  })
}
  